export default __webpack_public_path__ + "static/media/waves.bee22443.svg";